import { render, staticRenderFns } from "./ServiceTable.vue?vue&type=template&id=4ee49a4b&scoped=true&"
var script = {}
import style0 from "./ServiceTable.vue?vue&type=style&index=0&id=4ee49a4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee49a4b",
  null
  
)

export default component.exports